import React, { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';

import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

import config from '../../firebaseConfig/config.json';
import { takePendingWallboardSessionToken } from '../../screens/WallboardPlayer/pendingSessionToken';
import BrandedBootLoader from '../BrandedBootLoader';

const FirebaseGate = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const [firebaseReady, setFirebaseReady] = useState<boolean>(false);
  useEffect(() => {
    const init = async () => {
      if (!firebase.apps.length) {
        firebase.initializeApp(config);
      }

      // A wallboard TV upgrading to a screenshot-only session: sign in with the
      // new token (replacing the legacy session) before the app mounts.
      const pendingWallboardToken = takePendingWallboardSessionToken();
      if (pendingWallboardToken) {
        try {
          await firebase
            .auth()
            .setPersistence(firebase.auth.Auth.Persistence.LOCAL);
          await firebase.auth().signInWithCustomToken(pendingWallboardToken);
        } catch (e) {
          // Stay on the legacy session; the player retries the upgrade.
          // eslint-disable-next-line no-console
          console.error('Wallboard session upgrade sign-in failed', e);
        }
      }

      // Headless scheduled-report renderer: sign in with the per-run custom token
      // passed in the URL. Doing it in-browser (rather than injecting persisted
      // state) means persistence and the API-key referrer are handled exactly like
      // a normal login, and the session restores reliably across the app boot.
      const renderToken = new URLSearchParams(window.location.search).get(
        'renderToken',
      );
      if (renderToken && !firebase.auth().currentUser) {
        try {
          await firebase
            .auth()
            .setPersistence(firebase.auth.Auth.Persistence.LOCAL);
          await firebase.auth().signInWithCustomToken(renderToken);
        } catch (e) {
          // Leave unauthenticated; AuthenticationProvider will handle it.
          // eslint-disable-next-line no-console
          console.error('renderToken sign-in failed', e);
        }
      }

      setFirebaseReady(true);
    };
    init();
  }, []);

  if (!firebaseReady) {
    return <BrandedBootLoader />;
  }

  return <>{children}</>;
};

export default FirebaseGate;
